class Ressorts {
  root: HTMLElement | null;
  list: HTMLElement | null;
  items: HTMLElement[];
  btnLeft: HTMLElement | null;
  btnRight: HTMLElement | null;
  currentIndex: number;

   scrollPosition: number;

  constructor() {
    this.root = document.querySelector(".ressorts");
    if (!this.root) return;

    this.list = this.root.querySelector(".ressorts__list");
    this.items = Array.from(this.list?.children || []) as HTMLElement[];
    this.btnLeft = this.root.querySelector(".ressorts__button--left");
    this.btnRight = this.root.querySelector(".ressorts__button--right");
    this.currentIndex = 0;

      this.scrollPosition = 0;

    if (!this.list || !this.items.length || !this.btnLeft || !this.btnRight) return;

    this.init();
  }

  init() {
   const updateButtons = () => {
  const scrollLeft = this.list!.scrollLeft;
  const scrollWidth = this.list!.scrollWidth;
  const clientWidth = this.list!.clientWidth;

  const showLeft = scrollLeft > 0;
  const showRight = scrollLeft + clientWidth < scrollWidth - 1;

  this.btnLeft!.classList.toggle("is-visible", showLeft);
  this.btnRight!.classList.toggle("is-visible", showRight);

  this.root!.classList.toggle("has-left-button", showLeft);
};

const scrollRight = () => {
  if (this.currentIndex >= this.items.length) return;

  const width = this.items[this.currentIndex].getBoundingClientRect().width;

  this.scrollPosition += width;

  this.list!.scrollTo({
    left: this.scrollPosition,
    behavior: "smooth"
  });

  this.currentIndex++;
};


const scrollLeft = () => {
  if (this.currentIndex <= 0) return;

  const width = this.items[this.currentIndex - 1].getBoundingClientRect().width;

  this.scrollPosition -= width;

  this.list!.scrollTo({
    left: this.scrollPosition,
    behavior: "smooth"
  });

  this.currentIndex--;
};

    this.btnRight.addEventListener("click", scrollRight);
    this.btnLeft.addEventListener("click", scrollLeft);
    this.list.addEventListener("scroll", updateButtons);
    window.addEventListener("resize", updateButtons);

    updateButtons();
  }
}

export const simple1 = new Ressorts();









